<template>
<article>
    <header class="view__header">
      <h2 class="view__title">{{ L.localize('Settings_Import_Export_Breadcrumb') }}</h2>
    </header>
    <article class="view__content">
      <spinner v-if="loading"></spinner>

      <div class="view__panel">
          <submenu></submenu>

          <Btn @click="downloadExemple" label="Settings_Import_Export_DownloadExemple" float="right" :withBorder="true" />
          <div class="view__text">
            <p v-html="L.localize('ImportExport_EmptyValue')" />
            <p v-html="L.localize('ImportExport_AmendValue')" />
          </div>

          <div class="view__text">
            <Message :message="message" v-for="message in messages" />

            <div v-if="!cannotProceed">
              <p>{{ L.localize('ImportExport_Confirm') }}</p>
              <Btn @click="proceed" label="ImportExport_Confirm_Btn" />
              <Btn @click="cancel" label="ImportExport_Ignore_Btn" />
            </div>

            <div v-if="messages.length === 0">
              <fieldset class="form__field">
                <label for="fileUpload" class="form__label">{{ L.localize('Settings_Import_Export_SpecifyFileImport') }}</label>
                <input type="file" class="form__input" ref="fileUpload" accept=".csv" />
              </fieldset>

              <CheckBox v-model="isUpdateOnly" label="Label_UpdateOnly" notice="Label_UpdateOnly_Notice" acc="isUpdateOnly" />

              <Btn @click="importFile" label="Settings_Import_Export_ImportUsers" />
            </div>
          </div>
      </div>
    </article>
  </article>
</template>

<script>
import { Spinner } from 'components/partials'
import { TextBox, Btn, CheckBox } from 'components/layout/forms'
import { mapGetters } from 'vuex'
import Submenu from 'components/views/groups/Submenu'
import L from 'services/Localization'
import File from 'services/File'
import notifications from 'mixins/notifications'
import { Message } from 'components/layout'
import _ from 'lodash'

export default {
  name: 'import',
  components: { Submenu, TextBox, CheckBox, Btn, Spinner, Message },
  mixins: [notifications],
  data() {
    return {
      L: L,
      loading: false,
      messages: [],
      isUpdateOnly: false
    }
  },
  beforeCreate() {
    this.$store.dispatch('getGroup', this.$route.params.id)
  },
  computed: {
    ...mapGetters({
      group: 'activeGroup'
    }),
    cannotProceed() {
      return _.some(this.messages, { type: 1 }) || this.messages.length === 0
    }
  },
  methods: {
    downloadExemple: function() {
      File.download(`/settings/import-export/sample?groupId=${this.group.id}`).then((link) => { link.click() })
    },
    importFile: function() {
      this.loading = true
      var data = new FormData()
      data.append('file', this.$refs.fileUpload.files[0])
      data.append('groupImport', this.group.id)
      data.append('isUpdateOnly', this.isUpdateOnly)
      this.$store.dispatch('importMembers', data).then(
        // resolve
        (response) => {
          this.messages = response
          this.loading = false
        },
        // reject
        (response) => {
          this.loading = false
        }
      )
    },
    proceed: function() {
      this.loading = true
      this.$store.dispatch('proceedMembersImport', this.group.id).then(() => {
        this.loading = false
        this.messages = []
        this.showNotification({
          title: L.localize('Label_SuccessCreation'),
          message: L.localize('Settings_Group_Import_Export_Success')
        })
      })
    },
    cancel: function() {
      this.messages = []
    }
  }
}
</script>

<style lang='scss'>

</style>



// WEBPACK FOOTER //
// Import.vue?28aa606a